import { Headline, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import { formatCurrency } from '../utils/formatters';
import * as Styles from './currency-title.module.less';

interface CurrencyTitleProps {
    value: number;
    size: 'xlarge' | 'large' | 'medium';
    className?: string;
}

export const CurrencyTitle: FC<CurrencyTitleProps> = props => {
    const { className, size, value } = props;

    const currencyValue = formatCurrency(value);
    const [integerPart, decimalPart] = String(currencyValue).split('.');
    const decimalPartSize = size === 'xlarge' ? 'medium' : 'small';

    return (
        <Stack alignItems="flex-end" className={className}>
            <Headline size={size} el="p" className="m-b-0">
                {integerPart}
            </Headline>
            {!!decimalPart && (
                <Headline
                    size={decimalPartSize}
                    el="p"
                    className={classNames({
                        [Styles.decimalPartXlarge]: size === 'xlarge' || size === 'large',
                        [Styles.decimalPartMedium]: size === 'medium',
                    })}
                >
                    .{decimalPart}
                </Headline>
            )}
        </Stack>
    );
};
